export default {"src":"/_next/static/media/bridge.f2d3472e.svg","height":250,"width":1500,"blurWidth":0,"blurHeight":0};